export const audit = {
    title: "অডিট লগ",
    description: "কে, কখন, কী পরিবর্তন করেছেন। এন্ট্রি সম্পাদনা বা মুছে ফেলা যায় না।",
    columns: { time: "সময়", action: "কাজ", entity: "রেকর্ড", actor: "যিনি করেছেন" },
    actor: {
        user: "ব্যবহারকারী {{id}}",
        system: "সিস্টেম",
        device: "ডিভাইস {{id}}",
        platform: "প্ল্যাটফর্ম সাপোর্ট",
    },
    filters: {
        entity: "রেকর্ডের ধরন",
        action: "কাজ",
        from: "শুরু",
        to: "শেষ",
        apply: "প্রয়োগ করুন",
        clear: "মুছুন",
    },
    empty: "এই ফিল্টারে কোনো এন্ট্রি নেই।",
    details: {
        title: "এন্ট্রির বিস্তারিত",
        before: "আগে",
        after: "পরে",
        request: "রিকোয়েস্ট আইডি",
        ip: "আইপি ঠিকানা",
        device: "ডিভাইস",
    },
};
//# sourceMappingURL=audit.js.map